import * as React from 'react';
import type { SVGProps } from 'react';
const AdditivesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0003 8.99999V12.75M2.69731 16.126C1.83131 17.626 2.91431 19.5 4.64531 19.5H19.3553C21.0853 19.5 22.1683 17.626 21.3033 16.126L13.9493 3.37799C13.0833 1.87799 10.9173 1.87799 10.0513 3.37799L2.69731 16.126ZM12.0003 15.75H12.0073V15.758H12.0003V15.75Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default AdditivesIcon;
